(function (algolia) {
  if (!algolia.config.autocomplete_enabled) return;

  const { autocomplete } = algolia.externals;

  algolia.searchClient.addAlgoliaAgent('Shopify Integration');

  // Retrieve the container from Shopify's config
  const containers = Array.from(document.querySelectorAll(algolia.config.input_selector));
  containers.forEach((container) => {
    container.innerHTML = '';
    const containerClasses = container.classList;
    containerClasses.add('aa-MainContainer');
  });

  const getBaseUrlWithIso = algolia.helpers.getBaseUrlWithIso;
  let isImageAdded = false;
  // Set plugins
  const {
    collectionsPlugin,
  } = algolia;
  const plugins = [
    algolia.config.index_collections && collectionsPlugin,
  ];
  const cssFile = document.getElementById('template_algolia_autocomplete.css');

  // Set CSS variables
  document.documentElement.style.setProperty('--aa-text-color-rgb', `${algolia.helpers.hexToRGB(algolia.config.colors.secondary)}`);
  document.documentElement.style.setProperty('--aa-primary-color-rgb', `${algolia.helpers.hexToRGB(algolia.config.colors.main)}`);
  document.documentElement.style.setProperty('--aa-muted-color-rgb', `${algolia.helpers.hexToRGB(algolia.config.colors.muted)}`);
  document.documentElement.style.setProperty('--aa-highlight-color-rgb', `${algolia.helpers.hexToRGB(algolia.config.colors.highlight)}`);
  // Link CSS
  algolia.appendStyle(cssFile.text);

  let initialRender = false;
  const { locale } = window.Shopify;
  const autocompleteOptions = {
    openOnFocus: true,
    debug: algolia.config.autocomplete_debug,
    insights: algolia.config.analytics_enabled,
    placeholder: locale === 'fr' ? 'Recherche' : 'Search',
    plugins,
    async render({ elements, render, html, state }, root) {
      if (!initialRender) {
        initialRender = true;
        const topProductSuggestions = await getTopProductSuggestions();
        window.SDG.topProductSuggestions = topProductSuggestions;
      }
      const sourceIdsToExclude = ['products'];
      const hasLeftPanelResults = state.collections
        .filter(
          ({ source }) => sourceIdsToExclude.indexOf(source.sourceId) === -1,
        )
        .reduce((prev, curr) => prev + curr.items.length, 0) > 0;
      const [querySuggestionsPluginResults] = state.collections.filter(({ source }) => source.sourceId === 'querySuggestionsPlugin');
      const algoliaQuerySuggestions = querySuggestionsPluginResults
        ? querySuggestionsPluginResults.items
        : [];
      window.SDG.querySuggestionsPluginResults = querySuggestionsPluginResults;
      const panel = document.querySelector('.aa-Panel');
      const searchModal = document.querySelector('.search-modal');
      if (window.innerWidth > 768) {
        searchModal.appendChild(panel);
      }
      const leftPanel = document.querySelector('.aa-PanelSection--left');
      const inputSearch = document.querySelectorAll('.aa-Input');

      if (inputSearch.length > 0 && !isImageAdded) {
        const searchImg = document.createElement('img');
        searchImg.src = 'https://cdn.shopify.com/s/files/1/2304/1219/files/searchicon.png';
        searchImg.alt = 'Search Icon';
        searchImg.style.width = '20px';
        searchImg.style.height = '20px';
        searchImg.style.marginRight = '5px';
        searchImg.classList.add('aa-search-icon');
        inputSearch.forEach((input) => {
          const parent = input.parentNode;
          parent.insertBefore(searchImg, input);
        });

        isImageAdded = true;
      }

      // Algolia should return a list of popular searches. If not, display our own from a metaobject
      if (leftPanel && algoliaQuerySuggestions.length === 0) {
        const hasCustomList = document.querySelector('.aa-custom-list');
        const customPopularSearches = document.createElement('ul');
        const customHeader = document.createElement('span');
        customHeader.textContent = 'Trending Searches:';
        customHeader.classList.add('aa-SourceHeaderTitle');
        customPopularSearches.appendChild(customHeader);

        if (!hasCustomList) {
          const { popularSearches } = window.SDG;
          const values = popularSearches[0].popular_searches;
          values.forEach((value) => {
            const li = document.createElement('li');
            li.classList.add('aa-Item');
            li.classList.add('aa-Item--popular');
            li.innerHTML = `<a class="aa-ItemLink aa-ItemLink--popular" href="${getBaseUrlWithIso()}/search?q=${value}">
            <img src="https://cdn.shopify.com/s/files/1/2304/1219/files/searchicon.png" width="22" alt="Search Icon">${value}</a>`;
            customPopularSearches.appendChild(li);
          });

          customPopularSearches.classList.add('aa-List', 'aa-custom-list');
          leftPanel.appendChild(customPopularSearches);
        }
      }

      const displaySuggestions = algolia.config.autocomplete_query_suggestions
      && querySuggestionsPluginResults.items.length > 0;

      render(
        hasLeftPanelResults
          ? algolia.mainTemplate({ html, state }, elements, displaySuggestions)
          : algolia.mainTemplate({ html, state }, elements),
        root,
      );
    },
    renderNoResults({ render, html, state }, root) {
      render(
        algolia.noResultsTemplate({ html, state }),
        root,
      );
    },
    onSubmit({ state }) {
      const searchUrl = locale === 'fr' ? `/fr/search?q=${state.query}` : `/search?q=${state.query}`;
      window.location.href = searchUrl;
    },
  };

  // Get top 3 product suggestions from product_query_suggestions index
  const productSuggestionsIndex = algolia.externals.algoliasearch(
    algolia.config.app_id,
    algolia.config.search_api_key,
  ).initIndex('product_query_suggestions');

  const getTopProductSuggestions = async () => {
    try {
      const { hits } = await productSuggestionsIndex.search('', {
        hitsPerPage: 3,
      });
      return hits;
    } catch (error) {
      console.error('Error fetching product suggestions:', error);
      return [];
    }
  };

  containers.forEach((container) => {
    autocomplete({
      container,
      onStateChange() {
        window.SDG.alogiaProductSkus = [];
      },
      ...autocompleteOptions,
    });
  });
}(window.algoliaShopify));
